export default __webpack_public_path__ + "static/media/Ocean tide3.22bceeb7.jpg";